export const CLIENTTYPE_CREATE_RESET = 'CLIENTTYPE_CREATE_RESET'
export const CLIENTTYPE_CREATE_SET_CREATED = 'CLIENTTYPE_CREATE_SET_CREATED'
export const CLIENTTYPE_CREATE_SET_ERROR = 'CLIENTTYPE_CREATE_SET_ERROR'
export const CLIENTTYPE_CREATE_SET_VIOLATIONS = 'CLIENTTYPE_CREATE_SET_VIOLATIONS'
export const CLIENTTYPE_CREATE_TOGGLE_LOADING = 'CLIENTTYPE_CREATE_TOGGLE_LOADING'
